module.exports = __webpack_public_path__ + "img/icon-back.1e0ad1ce.svg";